import request from './request';

export function representativeSearch(zipcode) {
  return request('get', `/apiv2/lobbying/${zipcode}/representatives`, {});
}

export function senatorSearch(state) {
  return request('get', `/apiv2/lobbying/${state}/senators`, {});
}

export function createLobby(id, data) {
  return request('post', `/apiv2/lobbying/${id}/create`, data);
}

export function getTemplate(type) {
  return request('get', `/apiv2/lobbying/${type}/template`, {});
}

export function getStates() {
  return request('get', `/apiv2/lobbying/states`, {});
}

export function getLeaderships() {
  return request('get', `/apiv2/officials/leaderships`, {});
}

export function getSearch(params) {
  return request('get', `/apiv2/officials/search`, params);
}

export function getLobbies(id, params) {
  return request('get', `/apiv2/officials/${id}/lobbies`, params);
}

export function getMyOfficials() {
  return request('get', `/apiv2/officials/my-officials`, {});
}

export function enhanceContent(data) {
  return request('post', `/api/ai/enhance`, data);
}

export function contactRepresentative(id, data) {
  return request('post', `/apiv2/officials/${id}/send-message`, data);
}

export function getCustomDefaultMessage() {
  return request('get', `/api/lobby/custom-default-message`, {});
}
